import { useMediaQuery, useTheme } from "@mui/material"
import { useEffect, useState } from "react"

type breakpointType = "mobile" | "small" | "desktop"

function useBreakpoint(): breakpointType {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const isSmall = useMediaQuery(theme.breakpoints.between("sm", "xl"))

    if (isMobile) return "mobile"
    if (isSmall) return "small"
    return "desktop"
}

function getInitialSidebarPercent(breakpoint: breakpointType): number {
    switch (breakpoint) {
        case "mobile":
            return 1
        case "small":
            return 0.25
        case "desktop":
        default:
            return 0.35
    }
}

export function UseResponsiveSidebar(windowWidth: number): [
    number,
    breakpointType,
    React.Dispatch<React.SetStateAction<number>>
] {
    const breakpoint = useBreakpoint()
    const [currentBreakpoint, setCurrentBreakpoint] = useState(breakpoint)
    const [widthPercent, setWidthPercent] = useState(() =>
        getInitialSidebarPercent(breakpoint)
    )

    useEffect(() => {
        if (breakpoint !== currentBreakpoint) {
            setCurrentBreakpoint(breakpoint)
            setWidthPercent(getInitialSidebarPercent(breakpoint))
        }
    }, [breakpoint, windowWidth])

    return [widthPercent, currentBreakpoint, setWidthPercent]
}